import React from 'react'
import Layout from 'layouts/listing.js'
import Listing from 'components/listing.js'
import Breadcrumbs from 'components/breadcrumbs.js'
import Filters from 'components/filters'
import useGetSiteMetadata from 'hooks/useGetSiteMetadata'
import useGetAllBuilderProducts from 'hooks/useGetAllBuilderProducts'

export const Head = () => {
    const { brandName } = useGetSiteMetadata()
    return (
        <>
            <title>Mixers | {brandName}</title>
        </>
    )
}

export default function MixersPage({ path }) {
    const products = useGetAllBuilderProducts()
    const productsFiltered = products?.filter(({ legacy }) => !legacy)
        .filter(({ categories }) => categories?.lvl1?.includes('Products > Mixers'))
    
    // console.log(productsFiltered)
    return (
        <Layout
            n={productsFiltered?.length}
            customPadding='48px 32px 120px'
            css={{ borderTop: 'none' }}
        >
            <Breadcrumbs path={path} />
            <h1
                className='h3'
                style={{ marginBottom: 16 }}
            >
                Mixers
            </h1>
            <p
                className='sm w-md-50'
                style={{ marginBottom: 24 }}
            >
                RANE DJ mixers combine legendary build quality with precision control and exceptional audio clarity, delivering reliable performance for professional DJs in any environment.
            </p>
            <Filters style={{ marginBottom: 40 }} />
            <Listing items={productsFiltered} />
        </Layout>
    )
}
